import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import HotRankingSection from './components/HotRankingSection';
import FAQSection from './components/FAQSection';

const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '天美麻花星空影视',
  url: 'https://www.tianmeimahua.com/',
  description: '天美麻花星空影视提供海量高清影视资源，涵盖电影、电视剧、综艺、动漫等多种类型。',
  email: 'contact@tianmeimahua.com',
  telephone: '400-888-6666',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '北京',
    addressCountry: 'CN',
  },
};

const jsonLdWebsite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '天美麻花星空影视',
  url: 'https://www.tianmeimahua.com/',
  description: '天美麻花星空影视提供海量高清影视资源，电影在线观看、电视剧免费、综艺高清、最新影视。',
  potentialAction: {
    '@type': 'SearchAction',
    'target': 'https://www.tianmeimahua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '天美麻花星空影视是否需要注册才能观看？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '天美麻花星空影视大部分内容支持免费观看，部分最新院线大片可能需要注册会员后观看。注册完全免费，只需手机号即可完成。',
      },
    },
    {
      '@type': 'Question',
      name: '支持哪些设备观看？画质如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '天美麻花星空影视支持手机、平板、电脑等多种设备观看，画质提供标清、高清、超清多种选择，最高支持4K超高清画质。',
      },
    },
    {
      '@type': 'Question',
      name: '影片更新频率是怎样的？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们每日更新大量最新影视内容。热门电视剧当日更新，院线电影下映后1-3个月内上线，综艺节目播出后24小时内更新。',
      },
    },
    {
      '@type': 'Question',
      name: '天美麻花星空影视如何搜索我想看的影视内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以在首页顶部的搜索框中输入影片名称、演员或导演名称进行搜索。也可以通过分类导航浏览电影、电视剧、综艺、动漫等不同类型的内容。',
      },
    },
    {
      '@type': 'Question',
      name: '观看时需要缓冲吗？播放流畅吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '天美麻花星空影视采用先进的CDN加速技术，全国多节点服务器部署，确保观影流畅不缓冲。',
      },
    },
    {
      '@type': 'Question',
      name: '遇到播放问题如何联系客服？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过网站底部的"联系我们"获取客服联系方式，或发送邮件至 contact@tianmeimahua.com。',
      },
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrganization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebsite) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFAQ) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <HotRankingSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}